// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WQV5","col":"styles_col__1rG6f"};